var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClouds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 296,
    viewBox: "0 0 444 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_2_126)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2_126",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.563 151.351C211.683 151.352 211.804 151.353 211.924 151.353C229.087 151.353 243 137.44 243 120.277C243 103.115 229.087 89.2017 211.924 89.2017C211.804 89.2017 211.683 89.2024 211.563 89.2037V89.2017H203.535C203.825 87.075 203.975 84.9037 203.975 82.6975C203.975 56.3549 182.62 35 156.277 35C129.935 35 108.58 56.3549 108.58 82.6975C108.58 85.1831 108.77 87.6243 109.136 90.0074C106.868 89.4803 104.504 89.2017 102.076 89.2017C84.913 89.2017 71 103.115 71 120.277C71 137.44 84.913 151.353 102.076 151.353C102.197 151.353 102.318 151.352 102.439 151.351L102.437 151.353H211.563V151.351Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.563 151.351C211.683 151.352 211.804 151.353 211.924 151.353C229.087 151.353 243 137.44 243 120.277C243 103.115 229.087 89.2017 211.924 89.2017C211.804 89.2017 211.683 89.2024 211.563 89.2037V89.2017H203.535C203.825 87.075 203.975 84.9037 203.975 82.6975C203.975 56.3549 182.62 35 156.277 35C129.935 35 108.58 56.3549 108.58 82.6975C108.58 85.1831 108.77 87.6243 109.136 90.0074C106.868 89.4803 104.504 89.2017 102.076 89.2017C84.913 89.2017 71 103.115 71 120.277C71 137.44 84.913 151.353 102.076 151.353C102.197 151.353 102.318 151.352 102.439 151.351L102.437 151.353H211.563V151.351Z",
    fill: "url(#paint0_linear_2_126)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.563 151.351L211.586 149.351C211.052 149.345 210.537 149.553 210.157 149.929C209.777 150.304 209.563 150.816 209.563 151.351H211.563ZM211.563 89.2037H209.563C209.563 89.7381 209.777 90.2503 210.157 90.626C210.537 91.0017 211.051 91.2097 211.586 91.2036L211.563 89.2037ZM211.563 89.2017H213.563C213.563 88.0971 212.668 87.2017 211.563 87.2017V89.2017ZM203.535 89.2017L201.553 88.9315C201.475 89.5037 201.649 90.0818 202.028 90.5169C202.408 90.952 202.957 91.2017 203.535 91.2017V89.2017ZM109.136 90.0074L108.684 91.9555C109.33 92.1057 110.009 91.9253 110.496 91.4741C110.983 91.0228 111.214 90.3594 111.113 89.7033L109.136 90.0074ZM102.439 151.351L104.008 152.59C104.486 151.985 104.573 151.16 104.233 150.468C103.893 149.777 103.186 149.342 102.416 149.351L102.439 151.351ZM102.437 151.353L100.867 150.114C100.392 150.715 100.303 151.535 100.637 152.225C100.971 152.915 101.67 153.353 102.437 153.353V151.353ZM211.563 151.353V153.353C212.668 153.353 213.563 152.458 213.563 151.353H211.563ZM211.54 153.351C211.668 153.352 211.796 153.353 211.924 153.353V149.353C211.811 149.353 211.699 149.352 211.586 149.351L211.54 153.351ZM211.924 153.353C230.192 153.353 245 138.544 245 120.277H241C241 136.335 227.982 149.353 211.924 149.353V153.353ZM245 120.277C245 102.01 230.192 87.2017 211.924 87.2017V91.2017C227.982 91.2017 241 104.219 241 120.277H245ZM211.924 87.2017C211.796 87.2017 211.668 87.2024 211.54 87.2039L211.586 91.2036C211.699 91.2023 211.811 91.2017 211.924 91.2017V87.2017ZM209.563 89.2017V89.2037H213.563V89.2017H209.563ZM203.535 91.2017H211.563V87.2017H203.535V91.2017ZM205.517 89.4719C205.819 87.2559 205.975 84.9944 205.975 82.6975H201.975C201.975 84.8131 201.831 86.8941 201.553 88.9315L205.517 89.4719ZM205.975 82.6975C205.975 55.2503 183.724 33 156.277 33V37C181.515 37 201.975 57.4595 201.975 82.6975H205.975ZM156.277 33C128.83 33 106.58 55.2503 106.58 82.6975H110.58C110.58 57.4595 131.039 37 156.277 37V33ZM106.58 82.6975C106.58 85.2852 106.778 87.8281 107.16 90.3114L111.113 89.7033C110.762 87.4205 110.58 85.081 110.58 82.6975H106.58ZM109.589 88.0592C107.173 87.498 104.658 87.2017 102.076 87.2017V91.2017C104.351 91.2017 106.563 91.4627 108.684 91.9555L109.589 88.0592ZM102.076 87.2017C83.8085 87.2017 69 102.01 69 120.277H73C73 104.219 86.0176 91.2017 102.076 91.2017V87.2017ZM69 120.277C69 138.544 83.8085 153.353 102.076 153.353V149.353C86.0176 149.353 73 136.335 73 120.277H69ZM102.076 153.353C102.204 153.353 102.333 153.352 102.461 153.351L102.416 149.351C102.303 149.352 102.189 149.353 102.076 149.353V153.353ZM104.007 152.592L104.008 152.59L100.869 150.112L100.867 150.114L104.007 152.592ZM211.563 149.353H102.437V153.353H211.563V149.353ZM209.563 151.351V151.353H213.563V151.351H209.563Z",
    fill: "url(#paint1_linear_2_126)",
    mask: "url(#path-1-inside-1_2_126)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_2_126)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_2_126",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.5 230.997C305.666 230.999 305.833 231 306 231C329.748 231 349 211.748 349 188C349 164.252 329.748 145 306 145C305.833 145 305.666 145.001 305.5 145.003V145H294.391C294.793 142.057 295 139.053 295 136C295 99.5492 265.451 70 229 70C192.549 70 163 99.5492 163 136C163 139.439 163.263 142.817 163.77 146.115C160.631 145.386 157.361 145 154 145C130.252 145 111 164.252 111 188C111 211.748 130.252 231 154 231C154.168 231 154.335 230.999 154.502 230.997L154.5 231H305.5V230.997Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.5 230.997C305.666 230.999 305.833 231 306 231C329.748 231 349 211.748 349 188C349 164.252 329.748 145 306 145C305.833 145 305.666 145.001 305.5 145.003V145H294.391C294.793 142.057 295 139.053 295 136C295 99.5492 265.451 70 229 70C192.549 70 163 99.5492 163 136C163 139.439 163.263 142.817 163.77 146.115C160.631 145.386 157.361 145 154 145C130.252 145 111 164.252 111 188C111 211.748 130.252 231 154 231C154.168 231 154.335 230.999 154.502 230.997L154.5 231H305.5V230.997Z",
    fill: "url(#paint2_linear_2_126)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.5 230.997L305.523 228.997C304.988 228.991 304.474 229.199 304.094 229.575C303.714 229.951 303.5 230.463 303.5 230.997H305.5ZM305.5 145.003H303.5C303.5 145.537 303.714 146.049 304.094 146.425C304.474 146.801 304.988 147.009 305.523 147.003L305.5 145.003ZM305.5 145H307.5C307.5 143.895 306.605 143 305.5 143V145ZM294.391 145L292.41 144.73C292.332 145.302 292.505 145.88 292.885 146.315C293.265 146.75 293.814 147 294.391 147V145ZM163.77 146.115L163.318 148.063C163.964 148.213 164.643 148.033 165.13 147.582C165.617 147.13 165.848 146.467 165.747 145.811L163.77 146.115ZM154.502 230.997L156.072 232.237C156.549 231.632 156.637 230.807 156.297 230.115C155.957 229.423 155.25 228.988 154.479 228.997L154.502 230.997ZM154.5 231L152.931 229.76C152.455 230.362 152.366 231.182 152.7 231.872C153.034 232.562 153.733 233 154.5 233V231ZM305.5 231V233C306.605 233 307.5 232.105 307.5 231H305.5ZM305.477 232.997C305.651 232.999 305.825 233 306 233V229C305.841 229 305.682 228.999 305.523 228.997L305.477 232.997ZM306 233C330.853 233 351 212.853 351 188H347C347 210.644 328.644 229 306 229V233ZM351 188C351 163.147 330.853 143 306 143V147C328.644 147 347 165.356 347 188H351ZM306 143C305.826 143 305.651 143.001 305.477 143.003L305.523 147.003C305.682 147.001 305.841 147 306 147V143ZM303.5 145V145.003H307.5V145H303.5ZM294.391 147H305.5V143H294.391V147ZM296.373 145.27C296.787 142.238 297 139.143 297 136H293C293 138.962 292.799 141.876 292.41 144.73L296.373 145.27ZM297 136C297 98.4446 266.555 68 229 68V72C264.346 72 293 100.654 293 136H297ZM229 68C191.445 68 161 98.4446 161 136H165C165 100.654 193.654 72 229 72V68ZM161 136C161 139.542 161.271 143.021 161.793 146.419L165.747 145.811C165.255 142.614 165 139.337 165 136H161ZM164.223 144.167C160.937 143.403 157.514 143 154 143V147C157.207 147 160.326 147.368 163.318 148.063L164.223 144.167ZM154 143C129.147 143 109 163.147 109 188H113C113 165.356 131.356 147 154 147V143ZM109 188C109 212.853 129.147 233 154 233V229C131.356 229 113 210.644 113 188H109ZM154 233C154.175 233 154.35 232.999 154.525 232.997L154.479 228.997C154.32 228.999 154.16 229 154 229V233ZM156.069 232.24L156.072 232.237L152.933 229.757L152.931 229.76L156.069 232.24ZM305.5 229H154.5V233H305.5V229ZM303.5 230.997V231H307.5V230.997H303.5Z",
    fill: "url(#paint3_linear_2_126)",
    mask: "url(#path-3-inside-2_2_126)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_2_126)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_2_126",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.563 186.351C383.683 186.352 383.804 186.353 383.924 186.353C401.087 186.353 415 172.44 415 155.277C415 138.115 401.087 124.202 383.924 124.202C383.804 124.202 383.683 124.202 383.563 124.204V124.202H375.535C375.825 122.075 375.975 119.904 375.975 117.697C375.975 91.3549 354.62 70 328.277 70C301.935 70 280.58 91.3549 280.58 117.697C280.58 120.183 280.77 122.624 281.136 125.007C278.868 124.48 276.504 124.202 274.076 124.202C256.913 124.202 243 138.115 243 155.277C243 172.44 256.913 186.353 274.076 186.353C274.197 186.353 274.318 186.352 274.439 186.351L274.437 186.353H383.563V186.351Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.563 186.351C383.683 186.352 383.804 186.353 383.924 186.353C401.087 186.353 415 172.44 415 155.277C415 138.115 401.087 124.202 383.924 124.202C383.804 124.202 383.683 124.202 383.563 124.204V124.202H375.535C375.825 122.075 375.975 119.904 375.975 117.697C375.975 91.3549 354.62 70 328.277 70C301.935 70 280.58 91.3549 280.58 117.697C280.58 120.183 280.77 122.624 281.136 125.007C278.868 124.48 276.504 124.202 274.076 124.202C256.913 124.202 243 138.115 243 155.277C243 172.44 256.913 186.353 274.076 186.353C274.197 186.353 274.318 186.352 274.439 186.351L274.437 186.353H383.563V186.351Z",
    fill: "url(#paint4_linear_2_126)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.563 186.351L383.586 184.351C383.052 184.345 382.537 184.553 382.157 184.929C381.777 185.304 381.563 185.816 381.563 186.351H383.563ZM383.563 124.204H381.563C381.563 124.738 381.777 125.25 382.157 125.626C382.537 126.002 383.051 126.21 383.586 126.204L383.563 124.204ZM383.563 124.202H385.563C385.563 123.097 384.668 122.202 383.563 122.202V124.202ZM375.535 124.202L373.553 123.931C373.475 124.504 373.649 125.082 374.028 125.517C374.408 125.952 374.957 126.202 375.535 126.202V124.202ZM281.136 125.007L280.684 126.955C281.33 127.106 282.009 126.925 282.496 126.474C282.983 126.023 283.214 125.359 283.113 124.703L281.136 125.007ZM274.439 186.351L276.008 187.59C276.486 186.985 276.573 186.16 276.233 185.468C275.893 184.777 275.186 184.342 274.416 184.351L274.439 186.351ZM274.437 186.353L272.867 185.114C272.392 185.715 272.303 186.535 272.637 187.225C272.971 187.915 273.67 188.353 274.437 188.353V186.353ZM383.563 186.353V188.353C384.668 188.353 385.563 187.458 385.563 186.353H383.563ZM383.54 188.351C383.668 188.352 383.796 188.353 383.924 188.353V184.353C383.811 184.353 383.699 184.352 383.586 184.351L383.54 188.351ZM383.924 188.353C402.192 188.353 417 173.544 417 155.277H413C413 171.335 399.982 184.353 383.924 184.353V188.353ZM417 155.277C417 137.01 402.192 122.202 383.924 122.202V126.202C399.982 126.202 413 139.219 413 155.277H417ZM383.924 122.202C383.796 122.202 383.668 122.202 383.54 122.204L383.586 126.204C383.699 126.202 383.811 126.202 383.924 126.202V122.202ZM381.563 124.202V124.204H385.563V124.202H381.563ZM375.535 126.202H383.563V122.202H375.535V126.202ZM377.517 124.472C377.819 122.256 377.975 119.994 377.975 117.697H373.975C373.975 119.813 373.831 121.894 373.553 123.931L377.517 124.472ZM377.975 117.697C377.975 90.2503 355.724 68 328.277 68V72C353.515 72 373.975 92.4595 373.975 117.697H377.975ZM328.277 68C300.83 68 278.58 90.2503 278.58 117.697H282.58C282.58 92.4595 303.039 72 328.277 72V68ZM278.58 117.697C278.58 120.285 278.778 122.828 279.16 125.311L283.113 124.703C282.762 122.421 282.58 120.081 282.58 117.697H278.58ZM281.589 123.059C279.173 122.498 276.658 122.202 274.076 122.202V126.202C276.351 126.202 278.563 126.463 280.684 126.955L281.589 123.059ZM274.076 122.202C255.808 122.202 241 137.01 241 155.277H245C245 139.219 258.018 126.202 274.076 126.202V122.202ZM241 155.277C241 173.544 255.808 188.353 274.076 188.353V184.353C258.018 184.353 245 171.335 245 155.277H241ZM274.076 188.353C274.204 188.353 274.333 188.352 274.461 188.351L274.416 184.351C274.303 184.352 274.189 184.353 274.076 184.353V188.353ZM276.007 187.592L276.008 187.59L272.869 185.112L272.867 185.114L276.007 187.592ZM383.563 184.353H274.437V188.353H383.563V184.353ZM381.563 186.351V186.353H385.563V186.351H381.563Z",
    fill: "url(#paint5_linear_2_126)",
    mask: "url(#path-5-inside-3_2_126)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_2_126",
    x: 0,
    y: 0,
    width: 272,
    height: 216.353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2_126"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -21,
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113438 0 0 0 0 0.148981 0 0 0 0 0.275 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2_126",
    result: "effect2_dropShadow_2_126"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2_126",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_2_126",
    x: 40,
    y: 35,
    width: 338,
    height: 261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2_126"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -21,
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.14902 0 0 0 0 0.27451 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2_126",
    result: "effect2_dropShadow_2_126"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2_126",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_2_126",
    x: 172,
    y: 35,
    width: 272,
    height: 216.353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2_126"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -21,
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113438 0 0 0 0 0.148981 0 0 0 0 0.275 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2_126",
    result: "effect2_dropShadow_2_126"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2_126",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_126",
    x1: 165,
    y1: 38.5,
    x2: 165,
    y2: 164.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_126",
    x1: 157,
    y1: 35,
    x2: 157,
    y2: 151.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_126",
    x1: 230,
    y1: 18.5,
    x2: 230,
    y2: 253.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_126",
    x1: 230,
    y1: 70,
    x2: 230,
    y2: 231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_126",
    x1: 337,
    y1: 73.5,
    x2: 337,
    y2: 199.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_126",
    x1: 329,
    y1: 70,
    x2: 329,
    y2: 186.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClouds);
export default __webpack_public_path__ + "static/media/clouds.a37e06c0090bb28217c2a69fc4bdf374.svg";
export { ForwardRef as ReactComponent };